import styled from '@emotion/styled'
import { Shapes } from 'src/components/theme'
import { MapStyle } from 'src/types/map'

import MapSliverImage from 'src/assets/images/map-sliver.svg'
import MapSliverSatelliteImage from 'src/assets/images/map-sliver-satellite.svg'
import { FC } from 'react'
import { useRecoilValue } from 'recoil'
import { mapStyle } from 'src/atoms/main-map'

const Content = styled.div<{ imageUrl: string }>`
  position: absolute;
  top: 0;
  right: 0;
  height: 100vh;
  width: ${Shapes.insightsPageRightGap}px;
  background-image: url(${(props) => props.imageUrl});
  background-repeat: no-repeat;
  background-size: cover;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }
`

export const MapMock: FC = () => {
  const style = useRecoilValue(mapStyle)

  return (
    <Content className="no-print" imageUrl={style === MapStyle.STREETS ? MapSliverImage : MapSliverSatelliteImage} />
  )
}
